const VERIFIER_BYTES = 32;

export function generateCodeVerifier(): string {
    const bytes = new Uint8Array(VERIFIER_BYTES);
    crypto.getRandomValues(bytes);

    return base64Url(bytes);
}

export async function generateCodeChallenge(verifier: string): Promise<string> {
    const data = new TextEncoder().encode(verifier);
    const hash = await crypto.subtle.digest('SHA-256', data.buffer as ArrayBuffer);

    return base64Url(new Uint8Array(hash));
}

// the challenge travels in a url, so it needs the url safe alphabet and no padding
function base64Url(bytes: Uint8Array): string {
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}
